"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3316],{

/***/ 368464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(639996);



/***/ }),

/***/ 315241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FullPageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179220);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(474151);



// import interLoader from '../../../public/assets/images/inter-loader.gif';


function FullPageLoader() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var globalLoader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            globalLoader: state.commonReducer.globalLoader
        };
    }).globalLoader;
    return globalLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "global-loader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__/* .GlobalCfeLoader */ .I, {
            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
        })
    });
}


/***/ }),

/***/ 322101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(505152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(667294);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_ProductListWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(368464);
/* harmony import */ var src_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(698616);
/* harmony import */ var src_utils_themeImports__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(353978);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(268037);
/* harmony import */ var src_components_ProductCustomizationPopUp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(924648);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(313508);
/* harmony import */ var src_redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(847228);
/* harmony import */ var src_hooks_useSetWishlistState__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(106531);
/* harmony import */ var src_constants_wishlist__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(298627);
/* harmony import */ var src_utils_routes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(540190);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(731024);
/* harmony import */ var src_components_FullPageLoader_FullPageLoader__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(315241);

















var WishlistItemDeletionAlert = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4884), __webpack_require__.e(7477), __webpack_require__.e(4463)]).then(__webpack_require__.bind(__webpack_require__, 454463));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(454463)
            ];
        }
    }
});
var VariantSelectedListModal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 4557).then(__webpack_require__.bind(__webpack_require__, 284557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(284557)
            ];
        }
    }
});
var VariantChooseRepeatModal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2948).then(__webpack_require__.bind(__webpack_require__, 932948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(932948)
            ];
        }
    }
});
var VariantModal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1868), __webpack_require__.e(6873)]).then(__webpack_require__.bind(__webpack_require__, 740261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(740261)
            ];
        }
    }
});
var QuickViewModal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7856), __webpack_require__.e(9228), __webpack_require__.e(4429), __webpack_require__.e(526), __webpack_require__.e(8557), __webpack_require__.e(1788), __webpack_require__.e(5684), __webpack_require__.e(6966)]).then(__webpack_require__.bind(__webpack_require__, 75684));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75684)
            ];
        }
    }
});
var PromosDrawerAndButton = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6956), __webpack_require__.e(4814), __webpack_require__.e(6576), __webpack_require__.e(8487), __webpack_require__.e(3973), __webpack_require__.e(526), __webpack_require__.e(2031), __webpack_require__.e(9875), __webpack_require__.e(7909), __webpack_require__.e(4640), __webpack_require__.e(6307), __webpack_require__.e(2265), __webpack_require__.e(42)]).then(__webpack_require__.bind(__webpack_require__, 590042));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(590042)
            ];
        }
    }
});
var EmptyWishlistPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2931).then(__webpack_require__.bind(__webpack_require__, 432931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(432931)
            ];
        }
    }
});
var Wishlist = function(props) {
    var ref, ref1, ref2;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref3 = (0,src_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSSRSelector */ .kF)(function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            storeData: state.storeReducer.store,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct,
            userData: (ref1 = state.userReducer) === null || ref1 === void 0 ? void 0 : ref1.data,
            isLogin: (ref2 = state.userReducer) === null || ref2 === void 0 ? void 0 : ref2.isLogin,
            wishlistData: (ref3 = state.wishlistReducer) === null || ref3 === void 0 ? void 0 : ref3.data,
            wishlistFeatureActive: (ref4 = state.storeReducer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.store) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.services) === null || ref6 === void 0 ? void 0 : ref6.wishlist_flag,
            cartData: state.cartReducer
        };
    }), storeData = ref3.storeData, personalizedProduct = ref3.personalizedProduct, userData = ref3.userData, isLogin = ref3.isLogin, wishlistData = ref3.wishlistData, wishlistFeatureActive = ref3.wishlistFeatureActive, cartData = ref3.cartData;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(wishlistData || []), wishlistItemData = ref5[0], setWishlistItemData = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), firstRender = ref6[0], setFirstRender = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        open: false,
        confirmCallback: function(data) {}
    }), showDeleteConfirmationModal = ref7[0], setShowDeleteConfirmationModal = ref7[1];
    var setWishlistState = (0,src_hooks_useSetWishlistState__WEBPACK_IMPORTED_MODULE_11__/* .useSetWishlistState */ .X)().setWishlistState;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (wishlistFeatureActive !== src_constants_wishlist__WEBPACK_IMPORTED_MODULE_12__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE) {
            router.push((0,src_utils_routes__WEBPACK_IMPORTED_MODULE_13__.getRoute)(src_utils_routes__WEBPACK_IMPORTED_MODULE_13__.PATH._404));
            return;
        }
        if (!isLogin) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_15__/* .toggleGlobalAuthModal */ .Qi)(true));
            setLoading(false);
            return;
        }
        setFirstRender(false);
        fetchWishlistData();
    }, [
        cartData
    ]);
    var fetchWishlistData = function() {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            phone: userData === null || userData === void 0 ? void 0 : userData.phone
        };
        dispatch((0,src_redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_16__/* .getWishlistItemsByCustomerInfo */ .xV)(payload, function(data) {
            if (data) {
                changeWishlistItemStateToCart(data);
            } else {
                setWishlistItemData([]);
                setLoading(false);
            }
        }));
    };
    var deleteWishlistCallback = function(payload) {
        setWishlistState(payload, function(status) {
            if (status) {
                fetchWishlistData(); // wishlist item update after deleting a item from wishlist
            }
        }, {
            msg: "Wishlist item deleted successfully"
        });
        setShowDeleteConfirmationModal({
            open: false,
            confirmCallback: function(data) {}
        });
    };
    var handleWishlistDeleteClick = function(itemId) {
        setShowDeleteConfirmationModal({
            open: true,
            confirmCallback: function() {
                return deleteWishlistCallback({
                    item_id: itemId,
                    status: src_constants_wishlist__WEBPACK_IMPORTED_MODULE_12__/* .ITEM_WISHLIST_STATE.REMOVE_FROM_WISHLIST */ .U.REMOVE_FROM_WISHLIST
                });
            }
        });
    };
    var changeWishlistItemStateToCart = function(data) {
        var ref;
        var cartItemIds = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item.id || item.item_id;
        });
        // Set wishlist items that are present in the cart
        data === null || data === void 0 ? void 0 : data.forEach(function(item) {
            if (cartItemIds === null || cartItemIds === void 0 ? void 0 : cartItemIds.includes(item === null || item === void 0 ? void 0 : item.id)) {
                var payload = {
                    item_id: item === null || item === void 0 ? void 0 : item.id,
                    status: src_constants_wishlist__WEBPACK_IMPORTED_MODULE_12__/* .ITEM_WISHLIST_STATE.ADD_TO_CART */ .U.ADD_TO_CART
                };
                setWishlistState(payload, function(status) {}, !firstRender ? {
                    msg: "Item added to cart from wishlist"
                } : undefined);
            }
        });
        // Filter out wishlist items that are not in the cart
        var wishlistNotInCart = data === null || data === void 0 ? void 0 : data.filter(function(item) {
            return !cartItemIds.includes(item === null || item === void 0 ? void 0 : item.id);
        });
        setWishlistItemData(wishlistNotInCart);
        setLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "wishlist-page",
        children: [
            (ref = (0,src_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_6__/* .specificThemeRender */ .t)(storeData)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,src_utils_themeImports__WEBPACK_IMPORTED_MODULE_7__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "wishlist-loading",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_FullPageLoader_FullPageLoader__WEBPACK_IMPORTED_MODULE_14__/* .FullPageLoader */ .B, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: !wishlistItemData || wishlistItemData.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-w-full tw-h-[80vh] tw-flex tw-justify-center tw-items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmptyWishlistPage, {}),
                        " "
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_10__/* .IS_DESKTOP */ .yn ? "tw-px-[57px] tw-py-[36px]" : "tw-px-[11px] tw-py-[15px]"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "tw-font-inter tw-font-medium tw-text-[24px]",
                            children: "Wishlist"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_DesignSystem_Widgets2_0_ProductListWrapper__WEBPACK_IMPORTED_MODULE_5__/* .ProductListWrapper */ .X, {
                            customClass: "tw-mt-[24px]",
                            productList: wishlistItemData,
                            oldCardConfigs: {
                                showButton: true,
                                noTagsReadState: "fromLength",
                                isWishlistCard: true,
                                onWishlistDeleteClick: handleWishlistDeleteClick
                            },
                            calculateSelfDimensions: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VariantModal, {
                isWishlistProductCard: true,
                isRedirect: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VariantChooseRepeatModal, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VariantSelectedListModal, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuickViewModal, {}),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ProductCustomizationPopUp__WEBPACK_IMPORTED_MODULE_9__/* .ProductCustomizationPopUp */ .X, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PromosDrawerAndButton, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistItemDeletionAlert, {
                showDeleteConfirmationModal: showDeleteConfirmationModal,
                setShowDeleteConfirmationModal: setShowDeleteConfirmationModal
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Wishlist);


/***/ }),

/***/ 106531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useSetWishlistState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40804);
/* harmony import */ var _redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(847228);
/* harmony import */ var src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(731024);









function useSetWishlistState() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            storeData: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store,
            userData: (ref1 = state.userReducer) === null || ref1 === void 0 ? void 0 : ref1.data,
            isLogin: (ref2 = state.userReducer) === null || ref2 === void 0 ? void 0 : ref2.isLogin
        };
    }), storeData = ref.storeData, userData = ref.userData, isLogin = ref.isLogin;
    var setWishlistState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(payload, callback) {
        var showCustomToast = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (!isLogin && (payload === null || payload === void 0 ? void 0 : payload.status) !== src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_WISHLIST_STATE.ADD_TO_CART */ .U.ADD_TO_CART) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .toggleGlobalAuthModal */ .Qi)(true));
            callback(false);
            return;
        }
        payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, payload), {
            user_id: userData === null || userData === void 0 ? void 0 : userData.user_id,
            user_phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            user_email: userData === null || userData === void 0 ? void 0 : userData.email
        });
        dispatch((0,_redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_7__/* .setItemWishlistState */ .qC)(payload, function(status) {
            if (status) {
                (payload === null || payload === void 0 ? void 0 : payload.status) !== src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_WISHLIST_STATE.ADD_TO_CART */ .U.ADD_TO_CART ? (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_2__/* .toastNotifySuccess */ .jh)((payload === null || payload === void 0 ? void 0 : payload.status) === src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_WISHLIST_STATE.ITEM_WISHLISTED */ .U.ITEM_WISHLISTED ? "Item added to wishlist" : "Item removed from wishlist") : showCustomToast && (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_2__/* .toastNotifySuccess */ .jh)("".concat((showCustomToast === null || showCustomToast === void 0 ? void 0 : showCustomToast.msg) || "Wishlist updated"));
                dispatch((0,_redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_7__/* .getWishlistItemCountByUser */ .OG)({
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id
                }));
                callback(true);
            }
        }));
    }, [
        isLogin,
        storeData
    ]);
    return {
        setWishlistState: setWishlistState
    };
}


/***/ }),

/***/ 755847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getMetaDescription; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getMetaDescription = function(storeInfo) {
    var seoDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    if (!storeInfo) return "";
    if (seoDetails) return seoDetails.description;
    var description = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_description;
    return description || "";
// const businessTypes = storeInfo.store_businesses;
// const isAddresVisible = storeInfo?.address?.visibility === 1 ? true : false;
// let match = 13;
// let description = '';
// // default
// if (businessTypes && businessTypes.length > 1) {
//   match = 11;
// } else if (
//   businessTypes &&
//   businessTypes.length === 1 &&
//   businessTypes[0].business_id === 8
// ) {
//   match = 11;
// } else if (businessTypes && businessTypes.length === 0) {
//   match = 11;
// }
// // Genral store
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 1)
//   match = 1;
// // Pharmacy & Wellness
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 2)
//   match = 2;
// // Mobile & Electronics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 3)
//   match = 3;
// // Clothing & Fashion
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 4)
//   match = 4;
// // Resturants, Food Joints & Bakery
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 5)
//   match = 5;
// // Stationary & Office Supplies
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 6)
//   match = 6;
// // Arts, Jewellery & Collections
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 7)
//   match = 7;
// // Fruits & Vegetables
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 13)
//   match = 8;
// // Furniture & Home Decor
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 14)
//   match = 9;
// // Beauty & Cosmetics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 15)
//   match = 10;
// // real estate
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16)
//   match = 12;
// switch (match) {
//   case 1:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Grocery & Dairy Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 2:
//     description = `Buy and Order online from  ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Pharmacy & Wellness Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 3:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Mobile & Electronics Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 4:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fashion Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 5:
//     description = `Order Food online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }|  Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     } . Order Now!`;
//     break;
//   case 6:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Stationary Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 7:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Arts, Jewellery & Collections Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 8:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fruits & Vegetables Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 9:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Furniture & Home Decor Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 10:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Beauty & Cosmetics Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 11:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 12:
//     description = `Buy / Sell / Rent your real estate dream property from ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     } | Real Estate Property ${storeInfo.store_info?.name}. Explore Now!`;
//     break;
//   default:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
// }
// return description;
};


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

}]);